import React, { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import { Link } from 'react-router-dom'
import NewsLists from '../../Component/news'
import { useTranslation } from 'react-i18next'
import { Context } from '../../Store/context'
import layoutBgImg from '../../Images/layout/news.jpg'
import GlobalLayout from '../../Component/layout/global-layout'
import { Get } from '../../api/services/api_helpers'


const data = [
  { id: 1, category: 'global', name: 'country_news' },
  { id: 2, category: 'local', name: 'judicial_news' },
  { id: 3, category: 'article', name: 'article' },
  { id: 4, link: '/gallery', name: 'photomaterials' },
  // { id: 5, link: '/video', name: 'video' }
]

const News = () => {
  const [allNews, setAllNews] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation();
  const { showError } = useContext(Context);
  const [selectedCategory, setSelectedCategory] = useState('global')
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const resultsPerPage = 10;


  useEffect(() => {
    setIsLoading(true)
    const getNews = async () => {
      try {
        const data = await Get(`news/?category=${selectedCategory}&page=${currentPage}`)
        setIsLoading(false)
        setAllNews(data.results);
        const totalItems = data.count || data.results.length;
        setTotalPages(Math.ceil(totalItems / resultsPerPage));
      } catch (error) {
        showError(error.message);
        setIsLoading(false)
      }
    }
    getNews()
  }, [currentPage, showError, selectedCategory])


  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category)
    setCurrentPage(1);
  }

  const filteredNews = allNews.filter(news => news.category === selectedCategory)

  return (
    <GlobalLayout 
      title={`${t(selectedCategory === 'global' ? 'country_news' :
        selectedCategory === 'local' ? 'judicial_news' :
          'article')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords="Tazelikler, Täzelikler, Hовости, Kazyyet habarlary, Kazyýet habarlary, Makalalar"
    >
      <div className='mb-20'>
        <Layout
          layoutBgImg={layoutBgImg}
          title={t(selectedCategory === 'global' ? 'country_news' :
            selectedCategory === 'local' ? 'judicial_news' :
              'article')}
        />

        <header className='flex justify-center mt-8 xxl:px-12 
                         px-4 xxxl:px-32 xxxxl:px-64 
                         xxxxxl:px-[400px] xxxxxxl:px-[650px] 
                         xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]'>
          <ul className='md:flex md:flex-wrap gap-3 bg-white 
                           justify-center w-full p-6 text-[14px]
                           dark:text-dark-text dark:bg-dark-box'>

            {data?.map((d) => (
              <li
                key={d.id}
                onClick={() => handleCategoryClick(d.category)}
                className={`relative py-1 md:py-0 cursor-pointer`}
              >
                <Link to={d.link} className="relative block group bg-blue
                                           p-4 dark:bg-dark-box dark:border 
                                           shadow">
                  <span className={`${selectedCategory === d.category ?
                    'text-primary dark:text-white' : ''}`}>
                    {t(d.name)}
                  </span>
                  <span
                    className={`
                        absolute bottom-0 right-0 h-[1.5px]  
                        bg-primary transition-all duration-300
                        w-0 group-hover:w-full origin-right
                  `}
                  ></span>
                </Link>
              </li>
            ))}
          </ul>
        </header>

        <NewsLists
          news={filteredNews}
          isLoading={isLoading}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />

      </div>
    </GlobalLayout>
  )
}

export default News;
